module.exports = __webpack_public_path__ + "img/statistics_dds.19150a6d.png";